import React from 'react';
import { useReveal } from '../lib/useReveal';
export function SystemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#3d2a5f] py-12 md:py-16 px-5 sm:px-6 border-t border-[#4d3a6f]" data-id="element-471">
      <div className="container mx-auto max-w-3xl text-center" data-id="element-472">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-473">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 leading-tight text-white" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-474">
            🏆 MEGAPACK MAESTRÍA REIKI
          </h2>
          <p className="text-[#c9a14d] text-xl md:text-2xl font-bold mb-4" data-id="element-475">
            6 Tomos + 6 Bonos — Niveles I, II y Maestría
          </p>
          <p className="text-white/80 text-lg md:text-xl font-medium" data-id="element-476">
            Todo resuelto — Todo en un solo lugar.
          </p>
        </div>
      </div>
    </section>;
}